import React, {FC} from 'react';
import clsx from 'clsx';
import { UAParser } from 'ua-parser-js';
import {KTIcon} from '@/_metronic/helpers';
import { IpData } from '../../core/_models';
import {ReactCountryFlag} from 'react-country-flag'

type Props = {
  ua: string
}

export const BrowserCell: FC<Props> = ({ua}) => {
  const { os, device, browser } = UAParser(ua);
  const brand = device.vendor || os.name

  return (
    <div className='d-flex align-items-center'>
      {/* begin:: Avatar */}
      <div className='overflow-hidden me-3'>
        <i
          className={`fa-solid fa-${device.type === 'mobile' ? 'mobile' : 'desktop' } fs-1`}
          title={`${device.type === 'mobile' ? 'Mobile' : 'Desktop' }`}
        ></i>
      </div>
      <div className='overflow-hidden me-3'>
        {brand ? (
          <i className={`fa-brands fa-${brand.toLowerCase()} fs-1`} title={brand}></i>
        ) : (
          <i className="fa-solid fa-question fs-1" title="Unkwown"></i>
        )}
      </div>
      <b>{browser.name}</b>
    </div>
  )
}

interface IpProps {
  ip: IpData
}

export const IpCell: FC<IpProps> = ({ ip }) => {
  return (
    <div className='d-flex align-items-center'>
      {/* begin:: Avatar */}
      <div className='d-flex flex-column'>
        <span className='text-gray-800 mb-1'>
          {(['vpn', 'tor', 'proxy', 'robot', 'server'] as (keyof IpData)[]).map((d) => (
            <span
              key={d}
              title={d.toUpperCase()}
              className={clsx('badge me-1', {
                'badge-secondary': !ip[d],
                'badge-danger': ip[d],
              })}
            >
              {d[0].toUpperCase()}
            </span>
          ))}
          <span className={clsx('badge', {
            'badge-success': ip.score < 30,
            'badge-primary': ip.score >= 30 && ip.score < 50,
            'badge-warning': ip.score >= 50 && ip.score < 70,
            'badge-danger': ip.score >= 70,
          })}>
            {ip.score}
          </span>
          <span
            className={clsx('ms-1 badge', {
              'badge-success': ip.risk === 'low',
              'badge-primary': ip.risk === 'medium',
              'badge-warning': ip.risk === 'high',
              'badge-danger': ip.risk === 'very high',
            })}
          >
            {ip.risk}
          </span>
        </span>
        <span className='text-gray-800 mb-1'>
          <ReactCountryFlag countryCode={ip.country} style={{ fontSize: '1.5em' }} className='me-3' title={ip.country}/>
          <span className="fs-8">{ip.organization}</span>
          <span className="badge badge-secondary ms-2">{ip.value}</span>
        </span>
      </div>
    </div>
  )
}

interface ProviderProps {
  provider?: string
}

export const ProviderCell: FC<ProviderProps> = ({ provider }) => (
  <div className="text-center">
    {provider === 'google' ? (
      <KTIcon iconName="google" className="fs-1" />
    ): (
      <KTIcon iconName="password-check" className="fs-1" />
    )}
  </div>
)

interface StatusProps {
  error?: string
}

export const StatusCell: FC<StatusProps> = ({ error }) => (
  <div className="text-center">
    {error ? (
      <span title={error}>
        <KTIcon iconName="cross-circle" className="fs-1 text-danger" />
      </span>
    ): (
      <KTIcon iconName="check-circle" className="fs-1 text-success" />
    )}
  </div>
)

